import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PersistedNotification, PersistedNotificationCreate, PersistedNotificationFilter } from '../data/persistedNotification';

export function createPersistedNotificationService(client: AxiosInstance) {
  return createCrudService<PersistedNotification, PersistedNotificationCreate, PersistedNotificationFilter>(
    client,
    '/notifications/PersistedNotification',
    'code',
  );
}

export type PersistedNotificationService = CrudService<PersistedNotification, PersistedNotificationCreate, PersistedNotificationFilter>;
